import React from "react";
import { LOGOS } from "../../brand";

/**
 * <Logo>
 * Renders an owner-approved Gadget Guy Media logo variant.
 * All variants are raster PNGs (per v2 pack — no vector master exists yet).
 *
 * variant options:
 *   "icon"                 → standalone Orbital G  (favicons, nav on small screens)
 *   "stacked"              → Orbital G + wordmark, stacked, no tagline
 *   "stacked-tagline"      → Orbital G + wordmark + "You Imagine It. I Build It."
 *   "horizontal"           → Orbital G + wordmark side-by-side, no tagline
 *   "horizontal-tagline"   → horizontal with tagline
 *   "mono"                 → grayscale reference
 *
 *  Height is the only sizing prop — width follows aspect ratio naturally.
 */
const SRC = {
  icon: LOGOS.orbitalG,
  stacked: LOGOS.stacked,
  "stacked-tagline": LOGOS.stackedWithTagline,
  horizontal: LOGOS.horizontal,
  "horizontal-tagline": LOGOS.horizontalWithTagline,
  mono: LOGOS.stackedMono,
};

const DEFAULT_ALT = {
  icon: "Gadget Guy Media",
  stacked: "Gadget Guy Media",
  "stacked-tagline": "Gadget Guy Media · You Imagine It. I Build It.",
  horizontal: "Gadget Guy Media",
  "horizontal-tagline": "Gadget Guy Media · You Imagine It. I Build It.",
  mono: "Gadget Guy Media",
};

export const Logo = ({
  variant = "horizontal",
  height = 40,
  alt,
  className = "",
  style = {},
  loading = "eager",
  ...rest
}) => {
  const src = SRC[variant] ?? SRC.horizontal;
  return (
    <img
      src={src}
      alt={alt ?? DEFAULT_ALT[variant]}
      height={height}
      className={className}
      style={{ height, width: "auto", display: "block", ...style }}
      loading={loading}
      decoding="async"
      draggable={false}
      data-testid={`ggm-logo-${variant}`}
      {...rest}
    />
  );
};

export default Logo;
